import Vue from 'vue'
import Router from 'vue-router'
import grid from '@/components/grid'
import resume from '@/components/resume'
import gamePage from "@/components/gamePage";
import docPage from '@/components/docPage';
import vidPage from '@/components/vidPage';

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Annamaria Koshy',
            component: grid,
            meta: {
                title: 'Annamaria Koshy',
                metaTags: [
                    {
                        name: 'description',
                        content: 'Game Designer.'
                    },
                    {
                        property: 'og:description',
                        content: 'Game Designer.'
                    }
                ]
            }

        },
        {
            path: '/resume',
            name:'Resume',
            component: resume,
            meta: {
                title: 'Resume'
            }
        },
        {
            path: '/workplacehazards',
            name:'Workplace Hazards',
            component: gamePage,
            meta: {
                title: 'Workplace Hazards'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/workplacehazards",
                itchLink:"https://loch-nesrac.itch.io/workplace-hazards",
                theme: "wph",
                name: "Workplace Hazards",
                content: [{
                    video:'/assets/videos/wph.mp4',
                    flex:"one"
                },{
                    text:[
                        {
                            head:"Welcome to your mandatory Workplace Safety Training Module!",
                            text:"This short interactive guide is here to educate you and a fellow employee about the many dangers and hazards that can occur in the workplace.",
                        },{
                            text:" where players must utilize their dead bodies to solve puzzles and reach the exit. Stylized like a workplace safety training module, the levels often put the 'workers' in direct danger and require certain sacrifices to be made.",
                            head:"A local co-op puzzle platformer",
                        }],
                    flex:"two"
                },{
                    text:[
                        {
                            head:"Contributions",
                            text:"In this project, I had an all around role. From a programming and implementation" +
                                " perspective I created the base ragdoll character movement, statistic tracking, and" +
                                " blood splatter stains. From a visual design standpoint, I conceptualized and" +
                                " helped implement the hazard sign aesthetic and assisted in sprite design.",
                        },{
                            text:"I also was heavily involved in integration and bug-fixing. The largest portion" +
                                " of my contributions was getting the various systems and pieces made by" +
                                " individuals working together. This, ultimately, meant I had my hands in just" +
                                " about every system.",
                        }],
                    flex:"two"
                },
                    {
                        team:[{
                            member:"Annamaria Koshy",
                            roles:"Systems Programmer, Graphic Designer",
                        },{
                            member:"Carson Decker",
                            roles:"Systems Programmer, FX Artist, Level Designer",
                        },{
                            member:"Kate Howell",
                            roles:"Project Manager, Gameplay Programmer, Level Designer",
                        },{
                            member:"Logan Kornota",
                            roles:"Sprite Artist, Character Artist",
                        },{
                            member:"Luke Brockmann",
                            roles:"Writer, Graphic Designer, Level Designer",
                        }],
                        flex:"two",
                    },

                    {float:"left",
                        image:'https://img.itch.zone/aW1hZ2UvNTMwNDU1LzI3NTcyMTUucG5n/347x500/5Tuuz2.png',
                        flex:"one",
                    },
                    {
                        image:"https://img.itch.zone/aW1hZ2UvNTMwNDU1LzI3NTcyMTUucG5n/347x500/5Tuuz2.png",
                        flex:"one",
                    }
                ]
            }
        },
        {
            path: '/scorchedstatesman',
            name:'The Scorched Statesman',
            component: gamePage,
            meta: {
                title: 'The Scorched Statesman'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/scorchedstatesman",
                itchLink:"https://annamariakoshy.itch.io/shcd-scorched-statesman",
                theme: "ss",
                name: "The Scorched Statesman",
                content: [{
                    image:'/assets/images/scorched.png',
                    flex:"one"
                },{
                    text:[{
                        text:"When a young man's sister comes to Sherlock desperate to clear her brother's name," +
                            " you're given the case and must figure out what exactly happened and who the real" +
                            " arsonist is. The twist? Her brother's already confessed to the crime.",
                        head:"A painting, a confession, and plenty of suspects",
                    },
                        {
                            head:"An open and shut arson case",
                            text:"But things are hardly ever what they seem when you work for <a class='l'" +
                                " href='https://g.co/kgs/PVJfBa' target='_blank'>Sherlock Holmes, Consulting Detective</a>. Dive" +
                                " into" +
                                " this custom expansion for the game of the same name and uncover the truth of the " +
                                "Scorched Statesman.",
                        },{
                        text:"At its core, this module is a mystery game, told in the form of short story blurbs" +
                            " to be read aloud. Players use the clues embedded in the booklet text, images, a" +
                            " map, and other \"props\" such as a newspaper to put together what the mystery" +
                            " actually was and solve the case."
                        }],
                    flex:"two"
                },{
                    text:[
                        {
                            head:"Contributions",
                            text:"This game was heavily narrative centric. It required a large amount of" +
                                " writing, editing, and tweaking. More than" +
                                " that, however, it required a well thought out and planned mystery. This" +
                                " project was largely a collaborative effort, with all of us together" +
                                " conceptualizing the mystery and building out the blocks of necessary" +
                                " information from there.",
                        },{
                            text:"In terms of personal contributions, as part of the design team, I helped" +
                                " conceptualize the mystery and the \"game\" as a whole. As a writer, I"+
                                " wrote and edited" +
                                " for the" +
                                " booklet. Finally, as a graphic designer, I" +
                                " created the booklet, the newspaper, and any visual assets used in the module. ",
                        }],
                    flex:"two"
                },
                    {
                        team:[{
                            member:"Annamaria Koshy",
                            roles:"Writer, Game Designer, Graphic Designer",
                        },{
                            member:"Matt Cutts",
                            roles:"Writer, Game Designer",
                        },{
                            member:"Rilee Horowitz",
                            roles:"Writer, Game Designer",
                        },{
                            member:"Luke Brockmann",
                            roles:"Writer, Game Designer, Handwriting Artist",
                        }],
                        flex:"two",
                    }
                ]
            }
        },
        {
            path: '/scarletpimpernel',
            name:'The  Adventures of Lady  Marguerite Blakeney',
            component: gamePage,
            meta: {
                title: 'The  Adventures of Lady  Marguerite Blakeney'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/scarletpimpernel",
                itchLink:"https://annamariakoshy.itch.io/scarlet",
                theme: "ss",
                name: "The  Adventures of Lady  Marguerite Blakeney",
                content: [{
                    image:'/assets/images/scarlet.png',
                    flex:"one"
                },{
                    text:[
                        {
                            head:"Enter the Scarlet Pimpernel as the infamous Marguerite Blakeney",
                            text:"Marguerite Blakeney is a much esteemed member of English high society. France, her" +
                                " homeland, is in the midst of the French revolution, and when her old friend" +
                                " Chauvelin shows up to request her help in catching the much sought after Scarlet" +
                                " Pimpernel, her life will never be the same.",
                        },{
                            text:"Based on <i>The Scarlet Pimpernel</i> novel, written by Baroness Orczy, this twine" +
                                " game puts the player in the shoes of the wife of the Scarlet Pimpernel and gives" +
                                " Marguerite agency to make choices and decisions that can impact France, the" +
                                " aristocracy, and her marriage.",
                        }],
                    flex:"two"
                },{
                    text:[
                        {
                            head:"Contributions",
                            text:"This was a solo project, completed over the course of three weeks. Utilizing a" +
                                " public domain IP, <i>The Scarlet Pimpernel</i>, I tried to stylize the writing" +
                                " and branching styles to mirror the original. It is unfinished, with a" +
                                " few paths ending abruptly due to the time constraint.",
                        }],
                    flex:"two"
                }]
            }
        },
        {
            path: '/hellisunderground',
            name:'Hell is Underground',
            component: gamePage,
            meta: {
                title: 'Hell is Underground'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/hellisunderground",
                itchLink:"https://kevin-ray.itch.io/hell-is-underground",
                theme: "hiu",
                name: "Hell is Underground",
                content: [{
                    image:'/assets/images/hell.png',
                    flex:"one"
                },{
                    image:'/assets/images/hiu2.png',
                    flex:"one"
                },{
                    text:[
                        {
                            head:"Welcome to Hell. Or the closest you'll get.",
                            text:"The subway is a chaotic swirling mess of stations, people, and bureaucracy." +
                                " And you've got to navigate it all.",
                        },{
                            text:" where the player must complete quests, explore the stations, and stumble through" +
                                " the wild and untameable place that is the subway. An homage to the craziness that" +
                                " is the MTA, we tried too capture the innate humor present in the subway on a day" +
                                " to day basis.",
                            head:"A first person adventure game",
                        }],
                    flex:"two"
                }, {
                        text:[
                            {
                                head:"Contributions",
                                text:"In this project, I was responsible for the questing system, the dialogue" +
                                    " system, and general bug fixing. It was a big project made over four weeks, so" +
                                    " I also contributed in the form of writing dialogue, set dressing and set-up," +
                                    " and" +
                                    " designing visual assets, such as posters and boards.",
                            }],
                        flex:"two"
                    },
                    {
                        team:[{
                            member:"Annamaria Koshy",
                            roles:"Programmer, Writer, Game Designer, Graphic Designer",
                        },{
                            member:"Kevin Ray",
                            roles:"Programmer, Game Designer",
                        },{
                            member:"Kate Howell",
                            roles:"Programmer, Game Designer",
                        },{
                            member:"Carsen Decker",
                            roles:"Programmer, Game Designer, Effects Specialist",
                        },{
                            member:"Rilee Horowitz",
                            roles:"Programmer, 3D Modeler",
                        },{
                            member:"Luke Brockmann",
                            roles:"Writer, Game Designer, Graphic Designer",
                        }],
                        flex:"two",
                    }
                ]
            }
        },
        {
            path: '/riseofthecurrent',
            name:'Rise of the Current',
            component: gamePage,
            meta: {
                title: 'Rise of the Current'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/riseofthecurrent",
                itchLink:"https://rileehorowitz.itch.io/rise-of-the-current",
                theme: "rotc",
                name: "Rise of the Current",
                content: [{
                    image:'/assets/images/rotc.png',
                    flex:"one"
                },{
                    text:[
                        {
                            head:"Enter an alternate timeline",
                            text:"where in the war for superiority, steam won and electricity was relegated to the" +
                                " underground. Join up with Tesla and the Current, a group of electricity" +
                                " wielding" +
                                " revolutionaries and embark on a mission for the good of electricity. Use gadgets," +
                                " talk your way through situations, and make" +
                                " your mark as the newest agent of the Current. It's all up to you now.",
                        },{
                            text:"This is a <a class='l' href='http://www.memento-mori.com/'>Parsely</a> module" +
                                " designed" +
                                " to center" +
                                " around player decision and the impact your" +
                                " choices can have on" +
                                " a crisis that will change the world, for better or for worse. The game requires a" +
                                " \"parser\" that guides the player through the experience, serving as sort of the" +
                                " computer for what is a tabletop version of an old adventure game.",
                        }],
                    flex:"two"
                },
                    {
                        text:[
                            {
                                head:"Contributions",
                                text:"Writing, graphic design, and game design, this project was a fun combo of my" +
                                    " three favored areas. Made over the course of a few weeks, we designed the" +
                                    " \"adventure\" and the" +
                                    " overall plot of the story first. Then we went on to specific puzzle design for" +
                                    " the smaller interactions. A bulk of the work was fleshing out the details and" +
                                    " providing the correct information and set up for the various \"commands\".",
                            },{
                                text:"Personally, I wrote several parts of the booklet, designed the booklet, and" +
                                    " helped in all game design parts of the project. Though we had trouble with the" +
                                    " Parsely system at first, by the end we created a product we were incredibly" +
                                    " happy with.",
                            }],
                        flex:"two"
                    },
                    {
                        team:[{
                            member:"Annamaria Koshy",
                            roles:"Writer, Game Designer, Graphic Designer",
                        },{
                            member:"Rilee Horowitz",
                            roles:"Writer, Game Designer",
                        },{
                            member:"Luke Brockmann",
                            roles:"Writer, Game Designer",
                        }],
                        flex:"two",
                    }
                ]
            }
        },
        {
            path: '/koalatea',
            name:'Koala-Tea',
            component: gamePage,
            meta: {
                title: 'Koala-Tea'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/koalatea",
                itchLink:"https://annamariakoshy.itch.io/koala-tea",
                theme: "kt",
                name: "Koala-Tea",
                content: [{
                    image:'/assets/images/koala.png',
                    flex:"one"
                },{
                    text:[
                        {
                            head:"On a Quest for the Legendary Golden Leaf",
                            text:"Koala-Tea is a lighthearted game with an Animal Crossing feel where you chill in" +
                                " various tea" +
                                " rooms throughout the world. Speak to other animals about a legendary golden leaf you need for your dream of starting a cafe of your" +
                                " very own!     ",
                        }],
                    flex:"two"
                },
                    {
                        text:[
                            {
                                head:"Contributions",
                                text:"I was the primary programmer for this project, setting up the game systems and" +
                                    " scenes. We used Ink in for the dialogue, so I was in charge of the" +
                                    " integrations there as well, particularly in regards to the linking of" +
                                    " variables and event triggers between the two. More atypically, I" +
                                    " also" +
                                    " was" +
                                    " primarily responsible" +
                                    " for setting up the scenes, 3D models, and sprites within Unity. I also added" +
                                    " sound and visual effects.",
                            }],
                        flex:"two"
                    },
                    {
                        team:[{
                            member:"Annamaria Koshy",
                            roles:"Programmer, Set Designer",
                        },{
                            member:"Samina Trachier",
                            roles:"Programmer, Game Designer, 3D Modeler, Artist",
                        },{
                            member:"Anjali Chavan",
                            roles:"Programmer, Graphic Designer",
                        },{
                            member:"Maddy Sutton",
                            roles:"Writer",
                        },
                            {
                                member:"Rachel Geng",
                                roles:"Artist"
                            }],
                        flex:"two",
                    }
                ]
            }
        },
        {
            path: '/standoff',
            name:'Standoff',
            component: gamePage,
            meta: {
                title: 'Standoff'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/standoff",
                theme: "kt",
                name: "Standoff",
                content: [{
                    image:'/assets/images/standoff.jpg',
                    flex:"one"
                },{
                    text:[
                        {
                            head:"Shoot your friends!",
                            text:"Standoff is a tabletop game centered around the idea of the craziest standoff the" +
                                "West has ever seen. Players aim their guns at their targets, then use cards to" +
                                " redirect, reaim, and neutralize their fellow players' attacks. Played over the" +
                                " course of a few rounds, try to be the last one standing in order to win the game.",
                        }],
                    flex:"two"
                },{
                        text:[
                            {
                                head:"Contributions",
                                text:"For this project, I helped redesign the overall concept, refine the new" +
                                    " card concepts and powers, and playtest and polish the system to a finer point." +
                                    " I" +
                                    " also" +
                                    " participated in card design, helping refine the overall look, as well as prop" +
                                    " design with the knife spinner, pistols, and sheriff's badge.",
                            }],
                        flex:"two"
                    },
                    {
                        team:[{
                            member:"Annamaria Koshy",
                            roles:"Game Designer, Graphic Designer",
                        },{
                            member:"Rilee Horowitz",
                            roles:"Game Designer, Graphic Designer",
                        },{
                            member:"Elizabeth Yuan",
                            roles:"Artist",
                        }],
                        flex:"two",
                    }
                ]
            }
        },
        {
            path: '/1403',
            name:'1403',
            component: gamePage,
            meta: {
                title: '1403'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/standoff",
                itchLink:"https://rileehorowitz.itch.io/1403",
                theme: "fot",
                name: "1403",
                content: [{
                    image:'/assets/images/1403l.png',
                    flex:"one"
                },{
                    image:'/assets/images/1403.png',
                    flex:"one"
                },{
                    text:[
                        {
                            head:"What does home mean to you?",
                            text:"The theme of the 2019 Global Game Jam was \"What Does Home Mean To You\", and we" +
                                " made a game based on Apartment 1403, a place we spent most of our time, hanging" +
                                " out and talking with friends. Our home was each other, and so we made this game to" +
                                " exemplify that." +
                                " 1403 is" +
                                " somewhere to chill, play games, and talk.",
                        },{
                            text:"A.K.A. an apartment simulation where you do what you know best: play games and" +
                                " provide emotional support.",
                        }],
                    flex:"two"
                },

                    {float:"left",
                        image:'https://ggj.s3.amazonaws.com/styles/game_content__wide/games/screenshots/1403-midgame_1.png?itok=Cwn1NqRK&timestamp=1548632884',
                        flex:"one",
                    },{
                        text:[
                            {
                                head:"Contributions",
                                text:"I developed the dialogue system for this game, complete with a timing" +
                                    " system for the sound effects in tandem with choices and replies. I also" +
                                    " helped design the overall structure of the game and did graphic design" +
                                    " work for some of the sprites and UI pieces.",
                            }],
                        flex:"two"
                    },
                    {
                        team:[{
                            member:"Annamaria Koshy",
                            roles:"Game Designer, Programmer, Graphic Designer, Writer",
                        },{
                            member:"Matt Cutts",
                            roles:"Game Designer, Programmer, Audio Designer, Writer",
                        },{
                            member:"Rilee Horowitz",
                            roles:"Game Designer, Programmer, Lighting Artist, Writer",
                        },{
                            member:"Luke Brockmann",
                            roles:"Game Designer, Graphic Designer, Writer, Voice Actor",
                        },{
                            member:"Kevin Ray",
                            roles:"Game Designer, Programmer, 3D Modeler, Lighting Artist",
                        },{
                            member:"Cindy Lin",
                            roles:"Artist",
                        }],
                        flex:"two",
                    }
                ]
            }
        },
        {
            path: '/donutcountyclone',
            name:'Donut County Clone',
            component: gamePage,
            meta: {
                title: 'Donut County Clone'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/donutcountyclone",
                itchLink:"https://annamariakoshy.itch.io/donut-county",
                theme: "dcc",
                name: "Donut County Clone",
                content: [{
                    video:'/assets/videos/DCC.mp4',
                    flex:"one"
                },{
                    image:'https://img.itch.zone/aW1hZ2UvNDIzMDM5LzIxMTA0MzcucG5n/original/9UxTKG.png',
                    flex:"one"
                },{
                    image:'/assets/images/6k7aT6.png',
                    flex:"one"
                },{
                    text:[
                        {
                            head:"Everyone loves Donut County!",
                            text:"This is not that. This is a clone we made of the Racoon Lagoon level from <a" +
                                " class='l' href='http://donutcounty.com/   '>Donut" +
                                " County.</a> Using that level as reference and nothing else, we recreated the" +
                                " models" +
                                " from scratch, programmed all the mechanics, and made as similar a match to that as" +
                                " we could."
                        }],
                    flex:"two"
                },{
                        text:[
                            {
                                head:"Contributions",
                                text:"I took on a simultaneous management and programmer role in this project. I" +
                                    " figured out and implemented the \"hole\" mechanic and also set up the majority" +
                                    " of the level, putting objects in place, getting the opening \"cinematic\"" +
                                    " functioning, and overall working on everything that brings it together.",
                            }],
                        flex:"two"
                    },
                    {
                        team:[{
                            member:"Annamaria Koshy",
                            roles:"Programmer, 3D Modeler, Graphic Designer",
                        },{
                            member:"Anjali Chavan",
                            roles:"Programmer, 3D Modeler",
                        },{
                            member:"Rilee Horowitz",
                            roles:"Programmer, 3D Modeler",
                        },{
                            member:"Ajali Harrison",
                            roles:"3D Modeler",
                        }],
                        flex:"two",
                    }
                ]
            }
        },
        {
            path: '/godsforsaken',
            name:'Gods Forsaken',
            component: gamePage,
            meta: {
                title: 'Gods Forsaken'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/godsforsaken",
                itchLink:"https://rileehorowitz.itch.io/gods-forsaken",
                ttsLink:"https://steamcommunity.com/sharedfiles/filedetails/?id=2279408589&searchtext=gods+forsaken",
                theme: "gf",
                name: "Gods Forsaken",
                content: [{
                    image:'/assets/images/sEOAB7f.png',
                    flex:"one"
                },{
                    image:"https://i.imgur.com/QdbylbE.png",
                    flex:"one"
                }   ,{
                    image:'https://i.imgur.com/S9VsVvY.png',
                    flex:"one"
                },{
                    text:[
                        {
                            head:"Somewhere in America...",
                            text:"A bunch of college students put together a board game based on the" +
                                " <i>American Gods</i> IP.",
                        },{
                            text:"Players take the roles of \"old gods\", listening closely to the tales told by" +
                                " their fellow players to garner belief. The three gods with the most belief at the" +
                                " end of the game win, but they must struggle against the shifting tides of an" +
                                " America coming into new eras, with newer and shinier gods arriving all the while.",
                            head:"A competitive storytelling board game",
                        }],
                    flex:"two"
                },{
                        text:[
                            {
                                head:"Contributions",
                                text:"This project was an interesting challenge. We were presented with the IP" +
                                    " <i>American Gods</i> and were tasked with designing a board game around it." +
                                    " It was quickly evident that this would be a difficult task, but starting out" +
                                    " with the inspiration from <i>A Quiet Year</i> we decided upon a story-telling" +
                                    " game centered around the development of an American community from the 18th" +
                                    " to late 20th century.",
                            },{
                                text:"In terms of more specific contributions, I wrote card prompts, designed the" +
                                    " structure of the game with my" +
                                    " fellow" +
                                    " designers, and did all of the graphic design work for this project.",
                            }],
                        flex:"two"
                    },
                    {
                        team:[{
                            member:"Annamaria Koshy",
                            roles:"Writer, Game Designer, Graphic Designer",
                        },{
                            member:"Matt Cutts",
                            roles:"Writer, Game Designer",
                        },{
                            member:"Rilee Horowitz",
                            roles:"Writer, Game Designer",
                        },{
                            member:"Luke Brockmann",
                            roles:"Writer, Game Designer",
                        }],
                        flex:"two",
                    }
                ]
            }
        },
        {
            path: '/namelesschatapp',
            name:'Nameless Chat App',
            component: gamePage,
            meta: {
                title: 'Nameless Chat App'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/namelesschatapp",
                itchLink:"https://annamariakoshy.itch.io/nameless-chat-app",
                theme: "nca",
                name: "Nameless Chat App",
                content: [{
                    image:'/assets/images/nameless.png',
                    flex:"one"
                }, {
                    text: [
                        {
                            head: "A Nameless Chat App",
                            text: "Where you reconnect with an old friend after months of not speaking. A short" +
                                " interaction simulation, made entirely in Processing.",
                        }, {
                            text: "This project was made over a few weeks, as a solo project. It is an homage to" +
                                " the feelings of drifting" +
                                " apart one tackles after going to college and losing touch with friends. It also" +
                                " was the first attempt I made at tackling narrative systems design and" +
                                " conversational" +
                                " interactions in a game setting.",
                        }],
                    flex: "two"
                }
                ]
            }
        },
        {
            path: '/site',
            name:'This Website',
            component: gamePage,
            meta: {
                title: 'This Website'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/site",
                theme: "site",
                name: "This Website",
                content: [{
                    image:'/assets/images/site.png',
                    flex:"one"
                }, {
                    text: [
                        {
                            head: "A Portfolio Site made by me",
                            text: "I designed this entire website by myself, created the logo, and coded the entire" +
                                " thing with the Vue.js framework.",
                        }, {
                            text: "This project was a challenge for myself. I wanted certain functionality that made" +
                                " most free website creators non-ideal for me and having had minor web development" +
                                " experience before, I decided <i>I</i> could design and make my own. I taught myself" +
                                " how to use Vue over the series of a few weeks in order to" +
                                " create this.",
                        }],
                    flex: "two"
                }
                ]
            }
        },
        {
            path: '/studioslaughter',
            name:'Studio Slaughter',
            component: gamePage,
            meta: {
                title: 'Studio Slaughter'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/studioslaughter",
                theme: "ss",
                name: "Studio Slaughter",
                content: [{
                    image:'/assets/images/studio.png',
                    flex:"one"
                },{
                    image:'/assets/images/studioslaughter.jpg',
                    flex:"one"
                },{
                    text:[
                        {
                            head:"Battle Your Way Out In Studio Slaughter",
                            text:"A four player free-for-all style board game where four movie characters must" +
                                " battle on the sets of Hollywood to determine who is the best star.",
                        },{
                            text:"As players move around the board, they must pick up weapons to kill other players" +
                                " and awards to try and win the game. The player with 8 awards wins the game.",
                        }],
                    flex:"two"
                },{
                    text:[
                        {
                            head:"Contributions",
                            text:"This was a two week project. As it was a team project, I collaborated with my" +
                                " peers and worked on game" +
                                " design. I also worked on it from a graphic design perspective, putting" +
                                " together the manual and components for the final board game.",
                        }],
                    flex:"two"
                },
                    {
                        team:[{
                            member:"Annamaria Koshy",
                            roles:"Game Designer, Graphic Designer",
                        },{
                            member:"Samina Trachier",
                            roles:"Artist, Game Designer",
                        },{
                            member:"Cindy Lin",
                            roles:"Artist, Game Designer",
                        }],
                        flex:"two",
                    }
                ]
            }
        },
        {
            path: '/screenplays',
            name:'Screenplays',
            component: docPage,
            meta: {
                title: 'Screenplays'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/screenplays",
                theme: "screen",
                name: "Screenplays",
                sps:[
                    {}
                ]
            }
        },
        {
            path: '/untitled',
            name:'Untitled',
            component: vidPage,
            meta: {
                title: 'Untitled'
            },
            props: {
                urlPath:"https://www.annamariakoshy.com/#/untitled",
                theme: "vids",
                name: "Untitled",
                src:"https://www.youtube-nocookie.com/embed/8VE5aejPDUQ?",
                youtube:"https://www.youtube.com/watch?v=8VE5aejPDUQ",
            }
        }
    ],
    data () {
        return {
            publicPath: process.env.BASE_URL
        }
    }
})